/* eslint-disable import/no-unresolved,import/first,no-console,no-new,import/no-extraneous-dependencies,max-len */
import * as all from '@jojocoders/jojonomic-ui';
import { layout } from 'vue-extend-layout';
import Vue from 'vue';
import stores from './stores/index';
import Storage from 'vue-ls';
import router from './router';
import VueQuillEditor from 'vue-quill-editor';
import VueLodash from 'vue-lodash';
import panZoom from 'vue-panzoom';
import lodash from 'lodash';
import * as monaco from 'monaco-editor';
import DatadogConfig from '@/configs/datadog';
import FlagSmithConfig from '@/configs/flagsmith';
import SentryConfig from '@/configs/sentry';

monaco.languages.registerCompletionItemProvider('javascript', {
  // eslint-disable-next-line
  provideCompletionItems: (model, position) => {
    return [
      {
        label: '_date.start_of_today',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.start_of_today();',
      },
      {
        label: '_date.end_of_today',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.end_of_today();',
      },
      {
        label: '_date.start_of_week',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.start_of_week()',
      },
      {
        label: '_date.end_of_week',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.end_of_week()',
      },
      {
        label: '_date.start_of_month',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.start_of_month()',
      },
      {
        label: '_date.end_of_month',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.end_of_month()',
      },
      {
        label: '_date.start_of_year',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.start_of_year()',
      },
      {
        label: '_date.end_of_year',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.end_of_year()',
      },
      {
        label: '_date.today',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_date.today()',
      },
      {
        label: '_user.user_company_id',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_user.user_company_id',
      },
      {
        label: '_user.company_id',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_user.company_id',
      },
      {
        label: '_user.email',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_user.email',
      },
      {
        label: '_user.position_id',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_user.position_id',
      },
      {
        label: '_user.token',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_user.token',
      },
      {
        label: '_sleep',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sleep',
      },
      {
        label: '_deviceInfo.type',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_deviceInfo.type',
      },
      {
        label: '_deviceInfo.platform',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_deviceInfo.platform',
      },
      {
        label: '_field',
        kind: monaco.languages.CompletionItemKind.Variable,
        insertText: '_field',
      },
      {
        label: '_record',
        kind: monaco.languages.CompletionItemKind.Variable,
        insertText: '_record',
      },
      {
        label: '_stopAutomation',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_stopAutomation()',
      },
      {
        label: '_readGoogleSheet',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_readGoogleSheet)',
      },
      {
        label: '_sqlFetch',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sqlFetch()',
      },
      {
        label: '_sqlExec',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sqlExec()',
      },
      {
        label: '_sqlDatabases',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sqlDatabases()',
      },
      {
        label: '_exportFormDataToGoogleSheet',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_exportFormDataToGoogleSheet()',
      },
      {
        label: '_exportToGoogleSheet',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_exportToGoogleSheet()',
      },
      {
        label: '_exportExcel',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_exportExcel()',
      },
      {
        label: '_exportExcelMultipleSheet',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_exportExcelMultipleSheet()',
      },
      {
        label: '_pagination.page',
        kind: monaco.languages.CompletionItemKind.Variable,
        insertText: '_pagination.page',
      },
      {
        label: '_sendEmail',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sendEmail()',
      },
      {
        label: '_auditTrail',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_auditTrail()',
      },
      {
        label: '_env.company_id',
        kind: monaco.languages.CompletionItemKind.Variable,
        insertText: '_env.company_id',
      },
      {
        label: '_bcrypt',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_bcrypt()',
      },
      {
        label: '_bcryptValidate',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_bcryptValidate()',
      },
      {
        label: '_sha1',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sha1()',
      },
      {
        label: '_sha256',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_sha256()',
      },
      {
        label: '_log',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_log()',
      },
      {
        label: '_base64encode',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_base64encode()',
      },
      {
        label: '_base64decode',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_base64decode()',
      },
      {
        label: '_hitExternalAPI',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_hitExternalAPI()',
      },
      {
        label: '_hitExternalAPIByForm',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_hitExternalAPIByForm()',
      },
      {
        label: '_generateJWT',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_generateJWT()',
      },
      {
        label: '_generateJWTJojonomic',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_generateJWTJojonomic()',
      },
      {
        label: '_validateJWT',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_validateJWT()',
      },
      {
        label: '_decodeJWT',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_decodeJWT()',
      },
      {
        label: '_base64EncodeImage',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_base64EncodeImage()',
      },
      {
        label: '_profile',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_profile()',
      },
      {
        label: '_profileByUserCompanyID',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_profileByUserCompanyID()',
      },
      {
        label: '_excelFormulaUtilities',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_excelFormulaUtilities()',
      },
      {
        label: '_resizeImageFromURL',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_resizeImageFromURL()',
      },
      {
        label: '_hitFunction',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_hitFunction()',
      },
      {
        label: '_findRecords',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_findRecords()',
      },
      {
        label: '_getUserByOrganigramID',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_getUserByOrganigramID()',
      },
      {
        label: '_response_status_code',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_response_status_code()',
      },
      {
        label: '_hmacSha256',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_hmacSha256()',
      },
      {
        label: '_aes256Encrypt',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_aes256Encrypt()',
      },
      {
        label: '_aes256Decrypt',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_aes256Decrypt()',
      },
      {
        label: '_convertJSONtoXML',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_convertJSONtoXML()',
      },
      {
        label: '_convertXMLtoJSON',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_convertXMLtoJSON()',
      },
      {
        label: '_qrcodeGenerate',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_qrcodeGenerate()',
      },
      {
        label: '_barcodeGenerate',
        kind: monaco.languages.CompletionItemKind.Function,
        insertText: '_barcodeGenerate()',
      },
    ];
  },
});

// import this project scss
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import './sass/main.scss';

// axios global
window.axios = require('axios');

async function initializeApp() {
  const keys = Object.keys(all);
  keys.forEach((data) => {
    if (Array.isArray(all[data])) {
      Vue.use(...all[data]);
    } else {
      Vue.use(all[data]);
    }
  });

  // Initialize Flagsmith
  await FlagSmithConfig();

  // Initialize Datadog
  DatadogConfig();

  // Initialize Sentry
  SentryConfig(Vue, router);

  Vue.use(VueQuillEditor);

  Vue.use(panZoom, { componentName: 'jPanZoom' });

  Vue.use(Storage);

  Vue.use(VueLodash, { name: 'custom', lodash });

  Vue.config.productionTip = false;

  new Vue({
    el: '#app',
    router,
    store: stores,
    ...layout,
  });
}

initializeApp().catch((err) => {
  console.error('Failed to initialize the app:', err);
});



// WEBPACK FOOTER //
// ./src/main.js